export default __webpack_public_path__ + "static/media/ishq12.948a2357.jpg";